module.exports = __webpack_public_path__ + "img/qhcy_1.b35de7ca.jpg";